import API from "helpers/api";
import { Apis } from "services/api";
import { getAPIResponse } from "helpers/getApiResponse";
import { processChipsForAPI } from "helpers/chipProcessor";

const fileOptions = { responseType: "blob" };

export const getCompletedServiceReport = async ({ serviceId, timeZone }) => {
	try {
		let response = await API.get(
			`${Apis.Reports}/completeService?serviceId=${serviceId}&timeZone=${timeZone}`,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getDefectPartsByWorkOrder = async ({ workOrder }) => {
	try {
		let response = await API.get(
			`${Apis.Reports}/partsByWorkOrder?workOrder=${workOrder}`,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getDefectsSummary = async ({
	fromDate,
	toDate,
	chips,
	pageNumber,
	sortField,
	sortOrder,
	pageSize,
	onlySAPErrors = false,
	onlyFLOC = false,
	onlyNewDefects = false,
	serviceId,
}) => {
	try {
		const chipsByType = processChipsForAPI(chips);
		const payload = {
			fromDate,
			toDate,
			pageNumber,
			sortField,
			sortOrder,
			pageSize,
			onlySAPErrors,
			onlyFLOC,
			onlyNewDefects,
			serviceId,
			siteDepartmentIds: chipsByType.siteDepartmentIds,
			siteAssetIds: chipsByType.siteAssetIds,
			modelIds: chipsByType.modelIds,
			defectWorkOrders: chipsByType.defectWorkOrders,
			serviceWorkOrders: chipsByType.serviceWorkOrders,
			defectStatusIds: chipsByType.defectStatusIds,
			defectTypeIds: chipsByType.defectTypeIds,
			defectRiskRatingIds: chipsByType.defectRiskRatingIds,
			systemIds: chipsByType.systemIds,
			textSearches: chipsByType.textSearches,
		};

		let response = await API.post(
			`${Apis.Reports}/defectsReport`,
			payload,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getDefectsByStatus = async ({
	fromDate,
	toDate,
	chips,
	pageNumber,
	sortField,
	sortOrder,
	pageSize,
	onlySAPErrors = false,
	onlyFLOC = false,
	onlyNewDefects = false,
	serviceId,
}) => {
	try {
		const chipsByType = processChipsForAPI(chips);
		const payload = {
			fromDate,
			toDate,
			pageNumber,
			sortField,
			sortOrder,
			pageSize,
			onlySAPErrors,
			onlyFLOC,
			onlyNewDefects,
			serviceId,
			siteDepartmentIds: chipsByType.siteDepartmentIds,
			siteAssetIds: chipsByType.siteAssetIds,
			modelIds: chipsByType.modelIds,
			defectWorkOrders: chipsByType.defectWorkOrders,
			serviceWorkOrders: chipsByType.serviceWorkOrders,
			defectStatusIds: chipsByType.defectStatusIds,
			defectTypeIds: chipsByType.defectTypeIds,
			defectRiskRatingIds: chipsByType.defectRiskRatingIds,
			systemIds: chipsByType.systemIds,
			textSearches: chipsByType.textSearches,
		};
		let response = await API.post(
			`${Apis.Reports}/defectsByStatus`,
			payload,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getDefectsByRisk = async ({
	fromDate,
	toDate,
	chips,
	pageNumber,
	sortField,
	sortOrder,
	pageSize,
	onlySAPErrors = false,
	onlyFLOC = false,
	onlyNewDefects = false,
	serviceId,
}) => {
	try {
		const chipsByType = processChipsForAPI(chips);
		const payload = {
			fromDate,
			toDate,
			pageNumber,
			sortField,
			sortOrder,
			pageSize,
			onlySAPErrors,
			onlyFLOC,
			onlyNewDefects,
			serviceId,
			siteDepartmentIds: chipsByType.siteDepartmentIds,
			siteAssetIds: chipsByType.siteAssetIds,
			modelIds: chipsByType.modelIds,
			defectWorkOrders: chipsByType.defectWorkOrders,
			serviceWorkOrders: chipsByType.serviceWorkOrders,
			defectStatusIds: chipsByType.defectStatusIds,
			defectTypeIds: chipsByType.defectTypeIds,
			defectRiskRatingIds: chipsByType.defectRiskRatingIds,
			systemIds: chipsByType.systemIds,
			textSearches: chipsByType.textSearches,
		};
		let response = await API.post(
			`${Apis.Reports}/defectsByRisk`,
			payload,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
export const getDefectsExcel = async ({
	fromDate,
	toDate,
	chips,
	pageNumber,
	sortField,
	sortOrder,
	pageSize,
	onlySAPErrors = false,
	onlyFLOC = false,
	onlyNewDefects = false,
	serviceId,
}) => {
	try {
		const chipsByType = processChipsForAPI(chips);
		const payload = {
			fromDate,
			toDate,
			pageNumber,
			sortField,
			sortOrder,
			pageSize,
			onlySAPErrors,
			onlyFLOC,
			onlyNewDefects,
			serviceId,
			siteDepartmentIds: chipsByType.siteDepartmentIds,
			siteAssetIds: chipsByType.siteAssetIds,
			modelIds: chipsByType.modelIds,
			defectWorkOrders: chipsByType.defectWorkOrders,
			serviceWorkOrders: chipsByType.serviceWorkOrders,
			defectStatusIds: chipsByType.defectStatusIds,
			defectTypeIds: chipsByType.defectTypeIds,
			defectRiskRatingIds: chipsByType.defectRiskRatingIds,
			systemIds: chipsByType.systemIds,
			textSearches: chipsByType.textSearches,
		};
		let response = await API.post(
			`${Apis.Reports}/defectsExcel`,
			payload,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
export const toolsSummary = async ({
	modelVersionId = "",
	modelVersionRoleId = "",
	modelVersionIntervalId = "",
	modelVersionArrangementId = "",
}) => {
	try {
		let response = await API.get(
			`${Apis.Reports}/toolsSummary?modelVersionID=${modelVersionId}&modelVersionRoleID=${modelVersionRoleId}&modelVersionIntervalID=${modelVersionIntervalId}&modelVersionArrangementID=${modelVersionArrangementId}`,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const partsSummary = async ({
	modelVersionId = "",
	modelVersionRoleId = "",
	modelVersionIntervalId = "",
	modelVersionArrangementId = "",
}) => {
	try {
		let response = await API.get(
			`${Apis.Reports}/partsSummary?modelVersionID=${modelVersionId}&modelVersionRoleID=${modelVersionRoleId}&modelVersionIntervalID=${modelVersionIntervalId}&modelVersionArrangementID=${modelVersionArrangementId}`,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const partsByTask = async ({
	modelVersionId = "",
	modelVersionRoleId = "",
	modelVersionIntervalId = "",
	modelVersionArrangementId = "",
}) => {
	try {
		let response = await API.get(
			`${Apis.Reports}/partsByTask?modelVersionID=${modelVersionId}&modelVersionRoleID=${modelVersionRoleId}&modelVersionIntervalID=${modelVersionIntervalId}&modelVersionArrangementID=${modelVersionArrangementId}`,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const toolsByTask = async ({
	modelVersionId = "",
	modelVersionRoleId = "",
	modelVersionIntervalId = "",
	modelVersionArrangementId = "",
}) => {
	try {
		let response = await API.get(
			`${Apis.Reports}/toolsByTask?modelVersionID=${modelVersionId}&modelVersionRoleID=${modelVersionRoleId}&modelVersionIntervalID=${modelVersionIntervalId}&modelVersionArrangementID=${modelVersionArrangementId}`,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const serviceSheet = async ({
	modelVersionId = "",
	modelVersionRoleId = "",
	modelVersionIntervalId = "",
	modelVersionArrangementId = "",
}) => {
	try {
		let response = await API.get(
			`${Apis.Reports}/serviceSheet?modelVersionID=${modelVersionId}&modelVersionRoleID=${modelVersionRoleId}&modelVersionIntervalID=${modelVersionIntervalId}&modelVersionArrangementID=${modelVersionArrangementId}`,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getModelTasksExcel = async ({ modelVersionId = "" }) => {
	try {
		let response = await API.get(
			`${Apis.Reports}/modeltaskexcel?modelVersionID=${modelVersionId}`,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getTasksWhereAssetUsed = async ({ siteAssetId }) => {
	try {
		let response = await API.get(
			`${Apis.Reports}/tasksWhereAssetUsed?siteAssetId=${siteAssetId}`,
			fileOptions
		);

		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getServiceListReport = async (payload) => {
	try {
		// Process chips using centralized utility function
		const chipsByType = processChipsForAPI(payload.chips);

		// Add status from filter to statuses array if present (same logic as transformToServiceSearchRequest)
		if (payload.status && payload.status !== "") {
			if (!chipsByType.statuses.includes(payload.status)) {
				chipsByType.statuses.push(payload.status);
			}
		}

		// Add search text to textSearches array if present
		if (payload.searchFilter && payload.searchFilter !== "") {
			if (!chipsByType.textSearches.includes(payload.searchFilter)) {
				chipsByType.textSearches.push(payload.searchFilter);
			}
		}

		// Transform the payload to match the search API format exactly
		const requestBody = {
			sortField: payload.sortField || "",
			sort: payload.sort || "asc",
			fromDate: payload.fromDate || "",
			toDate: payload.toDate || "",
			siteAppId: payload.siteAppId || null,
			timeZone: payload.timeZone || "",
			statusType: payload.statusType || "",
			siteDepartmentIds: payload.siteDepartmentIds || [],
			siteAssetIds: [...(payload.siteAssetIds || []), ...chipsByType.siteAssetIds],
			modelIds: [...(payload.modelIds || []), ...chipsByType.modelIds],
			serviceWorkOrders: [...(payload.serviceWorkOrders || []), ...chipsByType.serviceWorkOrders],
			intervals: [...(payload.intervals || []), ...chipsByType.intervals],
			roles: [...(payload.roles || []), ...chipsByType.roles],
			statuses: payload.statusId ? [payload.statusId] : [...chipsByType.statuses],
			textSearches: [
				...(payload.textSearches || []), // Include existing text searches
				...chipsByType.textSearches // Include text searches from chips (now includes searchFilter)
			],
		};

		let response = await API.post(
			`${Apis.Reports}/serviceList`,
			requestBody,
			fileOptions
		);
		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getServiceListExcel = async (payload) => {
	try {
		// Process chips using centralized utility function
		const chipsByType = processChipsForAPI(payload.chips);

		// Add status from filter to statuses array if present (same logic as transformToServiceSearchRequest)
		if (payload.status && payload.status !== "") {
			if (!chipsByType.statuses.includes(payload.status)) {
				chipsByType.statuses.push(payload.status);
			}
		}

		// Add search text to textSearches array if present
		if (payload.searchFilter && payload.searchFilter !== "") {
			if (!chipsByType.textSearches.includes(payload.searchFilter)) {
				chipsByType.textSearches.push(payload.searchFilter);
			}
		}

		// Transform the payload to match the search API format exactly
		const requestBody = {
			sortField: payload.sortField || "",
			sort: payload.sort || "asc",
			fromDate: payload.fromDate || "",
			toDate: payload.toDate || "",
			siteAppId: payload.siteAppId || null,
			timeZone: payload.timeZone || "",
			statusType: payload.statusType || "",
			siteDepartmentIds: payload.siteDepartmentIds || [],
			siteAssetIds: [...(payload.siteAssetIds || []), ...chipsByType.siteAssetIds],
			modelIds: [...(payload.modelIds || []), ...chipsByType.modelIds],
			serviceWorkOrders: [...(payload.serviceWorkOrders || []), ...chipsByType.serviceWorkOrders],
			intervals: [...(payload.intervals || []), ...chipsByType.intervals],
			roles: [...(payload.roles || []), ...chipsByType.roles],
			statuses: payload.statusId ? [payload.statusId] : [...chipsByType.statuses],
			textSearches: [
				...(payload.textSearches || []), // Include existing text searches
				...chipsByType.textSearches // Include text searches from chips (now includes searchFilter)
			],
		};

		let response = await API.post(
			`${Apis.Reports}/serviceList/csv`,
			requestBody,
			fileOptions
		);
		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};

export const getCMDataExport = async (payload) => {
	try {
		const chipsByType = processChipsForAPI(payload.chips);

		if (payload.status && payload.status !== "") {
			if (!chipsByType.statuses.includes(payload.status)) {
				chipsByType.statuses.push(payload.status);
			}
		}

		if (payload.searchFilter && payload.searchFilter !== "") {
			if (!chipsByType.textSearches.includes(payload.searchFilter)) {
				chipsByType.textSearches.push(payload.searchFilter);
			}
		}

		const requestBody = {
			sortField: payload.sortField || "",
			sort: payload.sort || "asc",
			fromDate: payload.fromDate || "",
			toDate: payload.toDate || "",
			siteAppId: payload.siteAppId || null,
			timeZone: payload.timeZone || "",
			statusType: payload.statusType || "",
			siteDepartmentIds: payload.siteDepartmentIds || [],
			siteAssetIds: [...(payload.siteAssetIds || []), ...chipsByType.siteAssetIds],
			modelIds: [...(payload.modelIds || []), ...chipsByType.modelIds],
			serviceWorkOrders: [...(payload.serviceWorkOrders || []), ...chipsByType.serviceWorkOrders],
			intervals: [...(payload.intervals || []), ...chipsByType.intervals],
			roles: [...(payload.roles || []), ...chipsByType.roles],
			statuses: payload.statusId ? [payload.statusId] : [...chipsByType.statuses],
			textSearches: [
				...(payload.textSearches || []),
				...chipsByType.textSearches
			],
			modelVersionTaskQuestionIds: payload.modelVersionTaskQuestionIds || null,
		};

		let response = await API.post(
			`${Apis.Reports}/cmDataExport`,
			requestBody,
			fileOptions
		);
		return { ...getAPIResponse(response), headers: response.headers };
	} catch (err) {
		return getAPIResponse(err?.response);
	}
};
